import type { Restaurant } from '@shared/types/restaurant';
import type { TimeSlotMenu } from '../types/timeSlots';

/** Gratuity applies when the restaurant switch is on or the menu charges it. Callers still gate on deposit. */
export function isGratuityEnabled(
  restaurantGratuity: boolean | undefined,
  menu: Pick<TimeSlotMenu, 'chargeTip'> | undefined,
): boolean {
  return restaurantGratuity === true || !!menu?.chargeTip;
}

/** The restaurant switch counts only when at least one rate is configured. */
export function restaurantGratuityOn(
  restaurant: Pick<Restaurant, 'allowGratuity' | 'specificServiceChargeOptions'>,
): boolean {
  return restaurant.allowGratuity === true && (restaurant.specificServiceChargeOptions?.length ?? 0) > 0;
}

/** Median of the configured rates; null when none is configured. */
export function defaultTipPercent(options: readonly number[] | null | undefined): number | null {
  if (!options || options.length === 0) return null;
  const sorted = [...options].sort((a, b) => a - b);
  return sorted[Math.floor(sorted.length / 2)];
}

/** The saved rate when it is one of the configured rates, otherwise the default; null when none is configured. */
export function resolveTipPercent(
  saved: number | null | undefined,
  options: readonly number[] | null | undefined,
): number | null {
  return saved != null && options?.includes(saved) ? saved : defaultTipPercent(options);
}
